module.exports = __webpack_public_path__ + "d6cc57e66a79990642a16b9796c54e8f.svg";